import React from 'react';
import { useSearchParams } from 'react-router-dom';
import './NoveltiesList.css';

// Placeholder data structure for all novelty categories
const NOVELTIES_DATA = {
  specials: [
    { name: 'Angoori Falooda', image: process.env.PUBLIC_URL + '/assets/nv/kwalityspecial/Angoorifalooda.jpg' },
    { name: 'Loaded Falooda', image: process.env.PUBLIC_URL + '/assets/nv/kwalityspecial/loadedfalooda.jpg' },
    { name: 'Rabdi Delight', image: process.env.PUBLIC_URL + '/assets/nv/kwalityspecial/rabdidelight.jpg' },
    { name: 'Chat Delight', image: process.env.PUBLIC_URL + '/assets/nv/kwalityspecial/Chatdelight.jpg' },
  ],
  
  'milkshakes': [
    { name: 'Shake - Mix Dry Fruit', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Butter Scotch', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Ferraro Rocher', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Chikoo Shikoo', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Coffee Mocha', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Mad Mango', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Pulpy Sitafal', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Creamy Vanilla', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Kit Kat', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Chocolate Nirvana', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Oreo Cookies', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Gulab Jamun', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Belgium Biscuit', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },  
    { name: 'Shake - M & M', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - My Strawberry', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Orange Pineapple', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Pineapple', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Strawberry Banana', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Very Berry', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Vanilla Chocolate Chip', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Anjeer', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Anjeer Badam', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Kaju Aneer', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Khajoor', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Mava Badam', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
    { name: 'Shake - Nutty Pistachio', image: process.env.PUBLIC_URL + '/assets/nv/nav.png' },
  ],
  falooda: [
    { name: 'Pista Falooda', image: process.env.PUBLIC_URL + '/assets//nv/falooda/pistafalooda.jpg' },
    { name: 'Pan Pasand Falooda', image: process.env.PUBLIC_URL + '/assets//nv/falooda/panpasandfalooda.jpg' },
    { name: 'Original Falooda', image: process.env.PUBLIC_URL + '/assets//nv/falooda/originalfalooda.jpg' },
    { name: 'Mango Masti Falooda', image: process.env.PUBLIC_URL + '/assets//nv/falooda/mangomastifalooda.jpg' },
    { name: 'Kesar Pista Falooda', image: process.env.PUBLIC_URL + '/assets//nv/falooda/kesarpistafalooda.jpg' },
    { name: 'Tutti Fruitti Falooda', image: process.env.PUBLIC_URL + '/assets//nv/falooda/tuttifruittifalooda.jpg' },
    { name: 'Dry Fruit Falooda', image: process.env.PUBLIC_URL + '/assets//nv/falooda/dryfruitfalooda.jpg' },
    { name: 'Butter Scotch Falooda', image: process.env.PUBLIC_URL + '/assets//nv/falooda/butterscotchfalooda.jpg' },
    { name: 'Chocolate Falooda', image: process.env.PUBLIC_URL + '/assets//nv/falooda/chocolatefalooda.jpg' },
    { name: 'Chikoo Falooda', image: process.env.PUBLIC_URL + '/assets//nv/falooda/chikoofalooda.jpg' },
  ],
  sundaes: [
    { name: 'Banana Split', image: process.env.PUBLIC_URL + '/assets//nv/sundaes/bananasplit.jpg' },
    { name: 'Shahi Dry Fruit Sundae', image: process.env.PUBLIC_URL + '/assets//nv/sundaes/shahidryfruitsundae.jpg' },
    { name: 'Fruit Mania Sundae', image: process.env.PUBLIC_URL + '/assets//nv/sundaes/fruitmaniasundae.jpg' },
    { name: 'Chocolate Brownie Sundae', image: process.env.PUBLIC_URL + '/assets//nv/sundaes/chocolatebrowniesundae.jpg' },
    { name: 'Mango Mood Sundaes', image: process.env.PUBLIC_URL + '/assets//nv/sundaes/mangomoodsundae.jpg' },
    { name: 'Hot Fudge Brownie', image: process.env.PUBLIC_URL + '/assets//nv/sundaes/hotfudgebrownie.jpg' },
  ],
  kulfi: [
    { name: 'Pista Kulfi Plate', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Mango Kulfi Plate', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Badam Kulfi Plate', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Malai Kulfi Plate', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Kesar Pista Kulfi Plate', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
  ],
  cassata: [
    { name: 'Cassata', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Cassatta Log', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Gadbad', image: process.env.PUBLIC_URL + '/assets//nv/cassata/gadbad.jpg' },
    { name: 'Rangeela', image: process.env.PUBLIC_URL + '/assets//nv/cassata/rangeela.jpg' },
  ],
  coffee: [
    { name: 'Cold Coffee', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Cold Coffee With Ice Cream', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Ice Cream Floats', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Masala Soda', image: process.env.PUBLIC_URL + '/assets//nv/coffee/masalasoda.png' },
  ],
  'fresh-juices': [
    { name: 'Sugarcane', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Fresh Juices', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Coconut Juice', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Grape Juice', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
  ],
  'ice-cream-cakes': [
    { name: '1/4 Sheet Cake', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: '6" Cake', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: '9" Cake', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Big Heart', image: process.env.PUBLIC_URL + '/assets//nv/icecreamcake/bigheart.jpg' },
    { name: 'Rectangle Cake', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Number Candle', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Candle (Letter / Musical)', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
    { name: 'Small Heart', image: process.env.PUBLIC_URL + '/assets//nv/nav.png' },
  ],
 
  'bombay-gola': [
    { name: 'Ice Dish', image: process.env.PUBLIC_URL + '/assets//nv/bombaygola/icedish.jpg' },
    { name: 'Bombay Gola', image: process.env.PUBLIC_URL + '/assets//nv/bombaygola/bombaygola.jpg' },
    { name: 'Gola Ganda', image: process.env.PUBLIC_URL + '/assets//nv/bombaygola/golaganda.jpg' },
  ],
};

// Mapping from type to display name
const CATEGORY_TITLES = {
  specials: 'Kwality Special',
  'milkshakes-falooda': 'Lassi & Badam Milk',
  milkshakes: 'Milkshakes',
  falooda: 'Falooda',
  sundaes: 'Sundaes',
  kulfi: 'Kulfi',
  cassata: 'Cassata',
  coffee: 'Coffee',
  'fresh-juices': 'Fresh Juices',
  'ice-cream-cakes': 'Ice Cream Cakes',
  'bombay-gola': 'Bombay Gola',
};

const NoveltiesList = ({ type: propType }) => {
  const [searchParams] = useSearchParams();
  const type = propType || searchParams.get('type') || 'all';

  let items = [];
  let title = '';
  if (type === 'all') {
    // Flatten all items from all categories
    items = Object.values(NOVELTIES_DATA).flat();
    title = 'All Novelties';
  } else {
    items = NOVELTIES_DATA[type] || [];
    title = CATEGORY_TITLES[type] || 'Our Novelties';
  }

  return (
<section className="novelties-list section" style={{paddingTop: '90px'}}>
  <div className="container">
    {/* Category title with decorative shapes */}
    <div className="novelties-category-title" id="novelties-category-title">
      <img
        src={process.env.PUBLIC_URL + '/assets/left.png'}
        alt=""
        className="category-shape left"
      />
      <span className="category-title-text">{title}</span>
      <img
        src={process.env.PUBLIC_URL + '/assets/right.png'}
        alt=""
        className="category-shape right"
      />
    </div>
    <div className="novelties-grid">
      {items.length === 0 ? (
        <div style={{ textAlign: 'center', width: '100%' }}>
          <p>No items found for this category. Please select another.</p>
        </div>
      ) : (
        items.map((novelty, idx) => (
          <div className="novelty-card" key={idx}>
            <div className="novelty-img-wrapper">
              <img
                src={novelty.image}
                alt={novelty.name}
                className="novelty-img"
              />
              <div className="novelty-name">{novelty.name}</div>
            </div>
          </div>
        ))
      )}
    </div>
  </div>
</section>

  );
};

export default NoveltiesList; 
 